import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import CustomerLogin from "@/pages/CustomerLogin";
import CustomerRegister from "@/pages/CustomerRegister";
import CustomerDashboard from "@/pages/CustomerDashboard";
import PartnerLogin from "@/pages/PartnerLogin";
import PartnerRegister from "@/pages/PartnerRegister";
import PartnerDashboard from "@/pages/PartnerDashboard";
import PartnerSettings from "@/pages/PartnerSettings";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { auth } from "@/lib/api";

const Guard = ({ role, children }) => {
  const r = auth.getRole();
  const t = auth.getToken();
  if (!t || r !== role) {
    if (role === "customer") return <Navigate to="/customer/login" replace />;
    if (role === "partner") return <Navigate to="/partner/login" replace />;
    if (role === "admin") return <Navigate to="/admin/login" replace />;
  }
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/customer/login" element={<CustomerLogin />} />
        <Route path="/customer/register" element={<CustomerRegister />} />
        <Route
          path="/customer/dashboard"
          element={
            <Guard role="customer">
              <CustomerDashboard />
            </Guard>
          }
        />
        <Route path="/partner/login" element={<PartnerLogin />} />
        <Route path="/partner/register" element={<PartnerRegister />} />
        <Route
          path="/partner/dashboard"
          element={
            <Guard role="partner">
              <PartnerDashboard />
            </Guard>
          }
        />
        <Route
          path="/partner/settings"
          element={
            <Guard role="partner">
              <PartnerSettings />
            </Guard>
          }
        />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <Guard role="admin">
              <AdminDashboard />
            </Guard>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
